import React, { Component } from "react";
import { Modal, Icon } from "semantic-ui-react";
import SearchInput from "../../../SearchInput";
import "./index.css";

class MobileSearchModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  render() {
    return (
      <div>
        <button className="-search-button" value="Rechercher" onClick={this.openModal}>
          <Icon name="search" className="-search-icon" />
        </button>
        <Modal
          basic
          size="small"
          dimmer="inverted"
          className="mobile-search-wrapper"
          open={this.state.isModalOpen}
          onClose={this.closeModal}
        >
          <Modal.Content>
            <p className="-search-meta">Type and press "enter" to search</p>
            <SearchInput className="-search-input" autoFocus postSearchAction={this.closeModal} />
          </Modal.Content>
        </Modal>
      </div>
    );
  }

  openModal() {
    this.setState({
      isModalOpen: true,
    });
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
    });
  }
}

export default MobileSearchModal;



// WEBPACK FOOTER //
// ./src/components/Header/Components/SearchModal/index.js